import { render, staticRenderFns } from "./ad-edit-bid-placement.vue?vue&type=template&id=2a894c23&scoped=true&"
import script from "./ad-edit-bid-placement.vue?vue&type=script&lang=js&"
export * from "./ad-edit-bid-placement.vue?vue&type=script&lang=js&"
import style0 from "./ad-edit-bid-placement.vue?vue&type=style&index=0&id=2a894c23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a894c23",
  null
  
)

export default component.exports